import { z } from 'zod/v4';

export const fuelLocationSchema = z.object({
  fuelLocationId: z.number(),
  fuelLocationValue: z.string(),
  region: z.string(),
  image: z.string().nullable(),
});

export type FuelLocation = z.infer<typeof fuelLocationSchema>;
